import { Entity, makeClone } from 'gossamer-unified';
import { Person } from './Person';
import { User } from './User';

import { USERS_I_CAN_SEE_ADMIN, USERS_I_CAN_UPDATE_ADMIN } from './SecurityRules';

export interface UserByEmailRow {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
}

const clone = makeClone();

export const UserByEmail: Entity<UserByEmailRow> = {
  id: 'UserByEmail',
  title: 'User by Email',
  service: 'main',
  rowLabel: (row: UserByEmailRow) => row.email,
  primaryKeyFields: ['email'],
  source: {
    tableName: 'public.user_view',
  },
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'id IN ' + USERS_I_CAN_SEE_ADMIN },
    { role: 'admin', action: 'all', access: 'conditional', condition: 'id IN ' + USERS_I_CAN_UPDATE_ADMIN },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['email', 'ASC']],
  defaultFilters: [{ fieldId: 'email', operator: 'ct', value: '' }],
  autoCompleterSearchExpression: { and: [{ fieldId: 'email', operator: 'ct', value: '[[SEARCH_TERM]]' }] },
  listRowLink: '/admin/user/display/{key}',
  fields: {
    id: clone(User.fields.id, { seq: 5, listColumn: false }),
    first_name: clone(Person.fields.first_name, { seq: 10, listColumn: true, fieldGroup: 'display' }),
    last_name: clone(Person.fields.last_name, { seq: 15, listColumn: true, fieldGroup: 'display' }),
    email: clone(User.fields.email, { seq: 20, listColumn: true, fieldGroup: 'display' }),
  },
};
